import React from 'react';
import MyTasks from './MyTask';

function EmpCompletedTask() {
  return <MyTasks defaultStatus="Completed" />;
}

export default EmpCompletedTask;